import dayjs from "dayjs";
import { http } from "../http-common";

// Endpoint paths are placeholders mirroring SurveyManagementService.jsx's Farmer
// endpoints until the backend team confirms the real Sub Grower survey APIs.
const getCropStage = (config = {}) => {
  return http.get(`/cropStagesSubGrower`, config);
};

const getCropYear = (config) => {
  return http.get(`/cropYears`, config);
};
const getSurveyApproverData = (params, config = {}) => {
  return http.post(
    `/subgrower-surveyApprover?pageNumber=${params?.pageNumber}&pageSize=${params?.size}&isVisitCompliance=${params?.isVisitCompliance}`,
    params,
    config
  );
};
const getHierarchyDropdown = (data, config = {}) => {
  return http.get(`/hierarchy/hierarchy-drop-down?isMuv=${data.isMuv}&cropYear=${data.cropYear}`, config);
};
const reopenSurveys = (params, config = {}) => {
  return http.post(
    `/subgrower-surveyApprover/updateSurveyStatus?statusToUpdate=${params?.statusToUpdate}`,
    params,
    config
  );
};
const getIsApprover = (cropYear, config = {}) => {
  return http.get(`/hierarchy/isApprover?cropYear=${cropYear}`, config);
};

const getImageUrl = (fileUrl) => {
  return http.get(`/storage?fileUrl=${fileUrl}`);
};

const getViewSurvey = (
  headerId,
  isVisitCompliance,
  cropStageCalendarId,
  headers
) => {
  return http.get(`/subgrower-surveyApprover/surveyDetail`, {
    params: {
      headerId,
      isVisitCompliance,
      // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
      cropStageCalenderId: cropStageCalendarId,
    },
    headers,
  });
};

const reopenSurvey = (cropStageCalendarId, headerIds, reopenComment, headers) => {
  return http.post(
    `/subgrower-surveyApprover/updateSurveyStatus?statusToUpdate=Re-Opened`,
    {
      // Backend field is misspelled "Calender" (not "Calendar") - must match exactly.
      cropStageCalenderId: cropStageCalendarId,
      headerIds,
      reopenComment,
      actionDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    },
    {
      headers,
    }
  );
};

const approveSurvey = (headerIds, headers, approverName) => {
  return http.post(
    `/subgrower-surveyApprover/updateSurveyStatus?statusToUpdate=Approved`,
    {
      headerIds,
      actionDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      approverName: approverName,
    },
    {
      headers,
    }
  );
};
const fetchPickListSurvey = (data, headers) => {
  return http.post("/picklist", data, headers);
};

const getLabelTranslations = (config) => {
  return http.get("/active-reportStaticTranslations", config);
};

const SurveyManagementSubGrowerService = {
  getCropYear,
  getCropStage,
  getSurveyApproverData,
  getHierarchyDropdown,
  reopenSurveys,
  getIsApprover,
  getImageUrl,
  getViewSurvey,
  reopenSurvey,
  approveSurvey,
  fetchPickListSurvey,
  getLabelTranslations,
};

export default SurveyManagementSubGrowerService;
